import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum PasswordIconVariant {
  DEFAULT = 'default',
  CHECK = 'check',
}

export interface IPasswordIconProps extends IConDefaultType {
  variant?: PasswordIconVariant;
}

function PasswordIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = PasswordIconVariant.DEFAULT,
}: IPasswordIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === PasswordIconVariant.DEFAULT && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16 9H8C5.79086 9 4 10.7909 4 13V17C4 19.2091 5.79086 21 8 21H16C18.2091 21 20 19.2091 20 17V13C20 10.7909 18.2091 9 16 9Z"
            stroke="#303037"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 9V7C8 5.93913 8.42143 4.92172 9.17157 4.17157C9.92172 3.42143 10.9391 3 12 3C13.0609 3 14.0783 3.42143 14.8284 4.17157C15.5786 4.92172 16 5.93913 16 7V9"
            stroke="#303037"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M12 14V16" stroke="#303037" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
      {variant === PasswordIconVariant.CHECK && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 13C5 11.3431 6.34315 10 8 10H16C17.6569 10 19 11.3431 19 13V13.083C19.7179 13.2034 20.3926 13.4513 21 13.8027V13C21 10.2386 18.7614 8 16 8H8C5.23858 8 3 10.2386 3 13V17C3 19.7614 5.23858 22 8 22H12.8027C12.4513 21.3926 12.2034 20.7179 12.083 20H8C6.34315 20 5 18.6569 5 17V13Z"
            fill="#303037"
          />
          <path
            d="M8 9V7C8 5.93913 8.42143 4.92172 9.17157 4.17157C9.92172 3.42143 10.9391 3 12 3C13.0609 3 14.0783 3.42143 14.8284 4.17157C15.5786 4.92172 16 5.93913 16 7V9"
            stroke="#303037"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M12 14V16" stroke="#303037" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 23C20.2091 23 22 21.2091 22 19C22 16.7909 20.2091 15 18 15C15.7909 15 14 16.7909 14 19C14 21.2091 15.7909 23 18 23ZM20.495 18.495C20.7683 18.2216 20.7683 17.7784 20.495 17.505C20.2216 17.2317 19.7784 17.2317 19.505 17.505L17.5 19.5101L16.495 18.505C16.2216 18.2317 15.7784 18.2317 15.505 18.505C15.2317 18.7784 15.2317 19.2216 15.505 19.495L17.005 20.995C17.2784 21.2683 17.7216 21.2683 17.995 20.995L20.495 18.495Z"
            fill="#00C3DD"
          />
        </svg>
      )}
    </i>
  );
}

export default PasswordIcon;
